// import React from 'react';
import { render } from '@testing-library/react';
import React, { useState, useEffect, PureComponent, useRef, useMemo, useCallback, Fragment } from 'react';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { NavLink } from 'react-router-dom';
import {
    BarChart,
    Bar,
    Cell,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    LineChart,
    Line,
    Legend,
    ReferenceLine,
    ResponsiveContainer,
  } from 'recharts';
  import { PieChart, Pie, Sector, } from "recharts";
import "./EpicfinanceTrends.css";
import { isEqual } from "lodash";
import * as ReactBootstrap from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import $ from 'jquery';

import config from '../config';
import Sidebar from '../SideMenu';
// import { Accordion } from "react-bootstrap";
// var Accordion = require('react-bootstrap').Accordion;
// var Panel = require('react-bootstrap').Panel;
// var responseData;
const colors = ['#1A1549','#9DB1DB','#D0DEF5','#99103B','#B85876','#D296A9','#dcdcdc','#666666','#404040','#262626']


const Fundinfoarray = []
const ShareClassarray = []

let bot3contriDummy = []


// const usePrevious = value => {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = value;
//   });
//   return ref.current;
// };


const data = [

  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    // amt: 2400,
  },
  {
    name: 'Page B',
    uv: -3000,
    pv: 1398,
    // amt: 2210,
  },
  {
    name: 'Page C',
    uv: -2000,
    pv: -9800,
    // amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    // amt: 2000,
  },
  {
    name: 'Page E',
    uv: -1890,
    pv: 4800,
    // amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: -3800,
    // amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    // amt: 2100,
  },

];

const VARdata = [
    {
      name: 'Page A',
      uv: 0.34,
    //   pv: 2400,
    //   amt: 2400,
    },
    {
      name: 'Page B',
      uv: 0.11,
    //   pv: 1398,
    //   amt: 2210,
    },
    {
      name: 'Page C',
      uv: -0.04,
    //   pv: -9800,
    //   amt: 2290,
    },
    {
      name: 'Page D',
      uv: 1.5,
    //   pv: 3908,
    //   amt: 2000, 
    },

  ];
  const SECdata = [
    {
      name: 'Page A',
      uv: -1,
    //   pv: 2400,
    //   amt: 2400,
    },
    {
      name: 'Page B',
      uv: -0.52,
    //   pv: 1398,
    //   amt: 2210,
    },
    {
      name: 'Page C',
      uv: -0.60,
    //   pv: -9800,
    //   amt: 2290,
    },
    {
      name: 'Page D',
      uv: 1.29,
    //   pv: 3908,
    //   amt: 2000, 
    },

  ];

  const Donutdata = [


    { name: "Group D", value: 3.1 },
    { name: "Group A", value: 71.9 },
    { name: "Group C", value: 16.4 },
    { name: "Group B", value: 8.6 },


  ];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent,value, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
  if(value > 5){
    return (
      
      <text x={x} y={ y} fill="white" className="text-size-a" textAnchor={x > cx ? 'start' : 'end'} >
      
        {`${ (value).toFixed(2)}%`}
      </text>
    )};
  };
  
  const DONUTCOLORS10 = [ "#1A1549","#9DB1DB","#E6EEF6","#dcdcdc","#666666","#404040","#262626","#99103B","#B85876","#D296A9"];

  const DONUTCOLORS7 = ['#1A1549','#9DB1DB','#D0DEF5','#99103B','#B85876','#D296A9','#dcdcdc','#666666','#404040','#262626'];
  
  const DONUTCOLORS5 = ['#1A1549','#9DB1DB','#D0DEF5','#99103B','#B85876','#D296A9','#dcdcdc','#666666','#404040','#262626']
  const DONUTCOLORS6 =  ['#1A1549','#9DB1DB','#D0DEF5','#99103B','#B85876','#D296A9','#dcdcdc','#666666','#404040','#262626']

  const renderColorfulLegendText = (value, entry) => {
    const { color } = entry;
    if(entry.payload.value != undefined){
      return <span className="legend-span">{value+' '+(entry.payload.payload.value).toFixed(2)+'%'}</span>;
    }else{
      return <span style={{ color:"#1a1549" }}>{value}</span>;
    }
  };

  const renderColor12fulLegendText = (value, entry ) => {
    const { color } = entry;

    return <span className="legend-span">{value+' '+(entry.payload.value)+'%'}</span>;
  };

  const renderCustomizedLabelFixed = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value, index ,name }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const labelarray=['#ffffff','#ffffff','#000000','#ffffff','#ffffff','#ffffff','#ffffff','#000000'];
  if(value > 5){
    const colors =labelarray[index]
    return (
      
      <text x={x} y={ y} fill={colors} className="text-size-a-wealth" textAnchor={x > cx ? 'start' : 'end'} >
      
        {`${ (value).toFixed(1)}%`}
      </text>
    )};
  };

  const renderCustomized12LabelFixed = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value, index ,name }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const labelarray=['#ffffff','#ffffff','#000000','#ffffff','#ffffff','#ffffff','#ffffff','#000000'];
  if(value > 5){
    const colors =labelarray[index]
    return (
      
      <text x={x} y={ y} fill={colors} className="text-size-a-wealth" textAnchor={x > cx ? 'start' : 'end'} >
      
        {`${ (value).toFixed(1)}%`}
      </text>
    )};
  };


const EpicipPCCNextGenFunction = () => {




const [products, setProducts] = useState([]);
const [productsVAR, setProductsVAR] = useState([]);
const [productsSectorPer, setProductsSectorPer] = useState([]);
const [productscommulativePerformanceQAUSD, setproductscommulativePerformanceQAUSD] = useState([]);
const [productscommulativePerformanceQDUSD, setproductscommulativePerformanceQDUSD] = useState([]);

const [productscommulativePerformanceQDEUR, setproductscommulativePerformanceQDEUR] = useState([]);

const [productscommulativePerformanceQAEUR, setproductscommulativePerformanceQAEUR] = useState([]);
const [productscommulativePerformanceQDGBP, setproductscommulativePerformanceQDGBP] = useState([]);
const [productscommulativePerformanceXCHF, setproductscommulativePerformanceXCHF] = useState([]);


const [productscommulativePerformanceB, setproductscommulativePerformanceB] = useState([]);
const [productscommulativePerformanceBEUR, setproductscommulativePerformanceBEUR] = useState([]);
const [productscommulativePerformanceC, setproductscommulativePerformanceC] = useState([]);
const [twelvemonPerfAGBP, settwelvemonPerfAGBP] = useState([]);
const [StateSession, setStateSession] = useState([]);

const [twelvemonPerfDUSD, settwelvemonPerfDUSD] = useState([]);
const [twelvemonPerfAEUR, settwelvemonPerfAEUR] = useState([]);
const [twelvemonPerfDEUR, settwelvemonPerfDEUR] = useState([]);
const [twelvemonPerfDGBP, settwelvemonPerfDGBP] = useState([]);
const [twelvemonPerfGGBP, settwelvemonPerfGGBP] = useState([]);


const [performanceSummary, setperformanceSummary] = useState([]);

const [RespPrtu, setRespPrtu] = useState([]);

const [PRTU, setPRTU] = useState([]);
const [arrPRTUState,setarrPRTUState]= useState([]);
const [PRTUDate,setPRTUDate]= useState([]);

const [DailyDate,setDailyDate]= useState([]);

const [HeadingState, setHeadingState] = useState([]);
const [ObjectiveState, setObjectiveState] = useState([]);
const [TeamState, setTeamState] = useState([]);
const[Summary,setSummary]= useState([]);

const[Literature,setLiterature]= useState([]);
const [FundNameState, setFundNameState] = useState([]);
const [LiteratureDataState, setLiteratureDataState] = useState([]);
const [KeyInveInfoState, setKeyInveInfoState] = useState([]);
const [PressCoverageState, setPressCoverageState] = useState([]);
const [ApplicationsState, setApplicationsState] = useState([]);
const [ReportsState, setReportsState] = useState([]);
const [offerDocumentState, setofferDocumentState] = useState([]);





const [twelvemonPerfBGBP, settwelvemonPerfBGBP] = useState([]);
const [twelvemonPerfBEUR, settwelvemonPerfBEUR] = useState([]);
const [twelvemonPerfCGBP, settwelvemonPerfCGBP] = useState([]);


const [AssetAllocation, setAssetAllocation] = useState([]);

const [CreditRating, setCreditRating] = useState([]);


const [top3response, settop3response] = useState([]);
const [bot3response, setbot3response] = useState([]);

const [InceptionData, setInceptionData] = useState([]);
// const [SessionUserResponse, setSessionUserResponse] = useState([]);
// const [UserResponse, setUserResponse] = useState([]);



const [SessionUserResponse, setSessionUserResponse] = useState([]);
const [SessionResponse, setSessionResponse] = useState([]);



// const [productscommulativePerformanceA, setproductscommulativePerformanceA] = useState([]);

const [products12monthsPerformance, setproducts12monthsPerformance] = useState([]);
const [productstop3contr, setproductstop3contr] = useState([]);
const [productsbot3contr, setproductsbot3contr] = useState([]);
const [productsCommentary, setproductsCommentary] = useState([]);
const [productsFundinfo, setproductsFundinfo] = useState([]);
const [CMSFundinfo, setCMSFundinfo] = useState([]);
const [CMSshareinfo, setCMSshareinfo] = useState([]);
const [productsShareClass, setproductsShareClass] = useState([]);
const [productsMonthlyPerf, setproductsMonthlyPerf] = useState([]);
const [portfolioStatus, setportfolioStatus] = useState(false);
const [performanceStatus1, setperformanceStatus1] = useState(false);

const [graphData, setgraphData] = useState([]);
const [regionBreakdown1, setregionBreakdown1] = useState([]);
const [netForeignA, setnetForeignA] = useState([]);
const [portfolioStatusState, setportfolioStatusState] = useState([]);
const [FXExposureState, setFXExposureState] = useState([]);

const [NFAState, setNFAState] = useState([]);



const [top10HoldingState, settop10HoldingState] = useState([]);

const [AssetAllocationState, setAssetAllocationState] = useState([]);
const [marketCapState, setmarketCapState]= useState([]);
const [equititeState, setequititeState]= useState([]);

const [DerVarState, setDerVarState]= useState([]);




const [regionBreakdownState, setregionBreakdownState]= useState([]);

const [sectorBreakdownState, setsectorBreakdownState]= useState([]);






const [graphDataVAR, setgraphDataVAR] = useState([]);
const[graphDataSectorPer,setgraphDataSectorPer]= useState([]);


const[cummulatovePerfData,setcummulatovePerfData]= useState([]);
const[cummulatovePerfAEURData,setcummulatovePerfAEURData]= useState([]);
const[cummulatovePerfDUSDData,setcummulatovePerfDUSDData]= useState([]);
const[CummulativeperfDEURData,setCummulativeperfDEURData]= useState([]);
const[CummulativeperfDGBPData,setCummulativeperfDGBPData]= useState([]);
const[CummulativeperXCHFArrData,setCummulativeperXCHFArrData]= useState([]);




const[cummulatovePerfBData,setcummulatovePerfBData]= useState([]);
const[CummulativeperfeBEURData,setCummulativeperfeBEURData]= useState([]);
const[CummulativeperfC,setCummulativeperfC]= useState([]);


const[TwelveMperfAGBPState,setTwelveMperfAGBPState]= useState([]);

const[TwelveMperfDUSDState,setTwelveMperfDUSDState]= useState([]);
const[TwelveMperfDGBPState,setTwelveMperfDGBPState]= useState([]);
const[TwelveMperfDEURState,setTwelveMperfDEURState]= useState([]);
const[TwelveMperfAEURState,setTwelveMperfAEURState]= useState([]);

const[TwelveMperfGGBPState,setTwelveMperfGGBPState]= useState([]);


const[PerformanceSummaryState,setPerformanceSummaryState]= useState([]);



// const[TwelveMperfAGBPState,setTwelveMperfAGBPState]= useState([]);
// const[TwelveMperfAGBPState,setTwelveMperfAGBPState]= useState([]);
// const[TwelveMperfAGBPState,setTwelveMperfAGBPState]= useState([]);



const[InceptionArrayState,setInceptionArrayState]= useState([]);


const[TwelveMperfBGBPState,setTwelveMperfBGBPState]= useState([]);
const[TwelveMperfBEURState,setTwelveMperfBEURState]= useState([]);
const[TwelveMperfCGBPState,setTwelveMperfCGBPState]= useState([]);




const[twelvemonPerfDiscreteAPI,settwelvemonPerfDiscreteAPI]= useState([]);
const[top3contriarray,settop3contriarray]= useState([]);
// const[RegionalBreakdownarray,setRegionalBreakdownarray]= useState([]);


const[top3contriState,settop3contriState]= useState([]);

const[bot3contriarray,setbot3contriarray]= useState([]);
const[Fundinfoarray,setFundinfoarray]= useState([]);
const[ShareClassarray,setShareClassarray]= useState([]);
const[CMSFundinfoarray,setCMSFundinfoarray]= useState([]);
const[CMSshareinfoarray,setCMSshareinfoarray]= useState([]);

const[monthlyPerformance2DArrayState,setmonthlyPerformance2DArrayState]= useState([]);
const[monthsArrayState,setmonthsArrayState]= useState([]);

const[Loading,setLoading]= useState(false);

const [productRegional, setproductRegional] = useState([]);
const [productstop10Holding, setproductstop10Holding] = useState([]);
const [productsmarketCap, setproductsmarketCap] = useState([]);
const [productSectorBreakdown, setproductSectorBreakdown] = useState([]);


const [productRegionBreakdown, setproductRegionBreakdown] = useState([]);

const [PortfolioStat, setPortfolioStat] = useState([]);
const [FxFwdExpStat, setFxFwdExpStat] = useState([]);
const [monthlyPerf, setMonthlyPerf] = useState([]);
const [NFAData, setNFAData] = useState([]);

// const twelvemonPerfDiscreteAPI = []
// const top3contriarray =[]
// const bot3contriarray = []
const [status, setstatus] = useState(false);
const SettingFunction=()=>{

  setStateSession(SessionResponse);

}

// $( document ).ready(function() {
//   // SettingFunction();
  

 
 

// });



useEffect(()=>{
  fetchsessionAPI()
  fetchMyAPI()
},[])
const Clicked=()=>{
  $("#literatureTab").click();
  literatureButton();

}

const literatureButton=()=>{

  let FundName;
  
  let LiteratureName;
  let FileName;
  let LiteratureDate;
  let LiteratureTitle;
  let FinancialTrendFund;
  let LiteratureSubHead;
  let OtherInfoLiteratureArr=[];
  let KeyInveInfoLiteratureArr=[];
  let pressCoverageLiteratureArr=[];
  let applicationsLiteratureArr=[];
  let reportsLiteratureArr=[];
  let offerDocumentsLiteratureArr=[];
  
  var LiteratureKeys = ["LiteratureNameKey","FileName","LiteratureDate","LiteratureTitle"];
  
    for(let i=0 ; i< Literature.length ;i++){
      let OtherInfoObj={};
      let KeyInveInfoObj={};
      let pressCoverageObj={};
      let applicationsObj={};
      let reportsObj={};
      let offerDocumentsObj={};
  
  
  
       
      FundName = Literature[i].fund_name;
      if(FundName == "ss_next_gen_pcc"){
       
  
      if(Literature[i].literature_name == "other_information"){
  
        FinancialTrendFund = FundName; 
        LiteratureTitle = Literature[i].title;
        LiteratureName = Literature[i].literature_name;
        FileName = Literature[i].file;
        LiteratureDate = Literature[i].date;
  
        OtherInfoObj[LiteratureKeys[0]] = LiteratureName;
        OtherInfoObj[LiteratureKeys[1]] = FileName;
        OtherInfoObj[LiteratureKeys[2]] = LiteratureDate;
        OtherInfoObj[LiteratureKeys[3]] = LiteratureTitle;
  
        OtherInfoLiteratureArr.push(OtherInfoObj);
      }
      if(Literature[i].literature_name == "key_investor_information"){
  
        FinancialTrendFund = FundName; 
        LiteratureTitle = Literature[i].title;
        LiteratureName = Literature[i].literature_name;
        FileName = Literature[i].file;
        LiteratureDate = Literature[i].date;
  
        KeyInveInfoObj[LiteratureKeys[0]] = LiteratureName;
        KeyInveInfoObj[LiteratureKeys[1]] = FileName;
        KeyInveInfoObj[LiteratureKeys[2]] = LiteratureDate;
        KeyInveInfoObj[LiteratureKeys[3]] = LiteratureTitle;
  
        KeyInveInfoLiteratureArr.push(KeyInveInfoObj);
  
      }
      if(Literature[i].literature_name == "press_Coverage"){
  
        FinancialTrendFund = FundName; 
        LiteratureTitle = Literature[i].title;
        LiteratureName = Literature[i].literature_name;
        FileName = Literature[i].file;
        LiteratureDate = Literature[i].date;
  
        pressCoverageObj[LiteratureKeys[0]] = LiteratureName;
        pressCoverageObj[LiteratureKeys[1]] = FileName;
        pressCoverageObj[LiteratureKeys[2]] = LiteratureDate;
        pressCoverageObj[LiteratureKeys[3]] = LiteratureTitle;
  
        pressCoverageLiteratureArr.push(pressCoverageObj);
  
      }
      if(Literature[i].literature_name == "applications"){
  
        FinancialTrendFund = FundName; 
        LiteratureTitle = Literature[i].title;
        LiteratureName = Literature[i].literature_name;
        FileName = Literature[i].file;
        LiteratureDate = Literature[i].date;
  
        applicationsObj[LiteratureKeys[0]] = LiteratureName;
        applicationsObj[LiteratureKeys[1]] = FileName;
        applicationsObj[LiteratureKeys[2]] = LiteratureDate;
        applicationsObj[LiteratureKeys[3]] = LiteratureTitle;
  
        applicationsLiteratureArr.push(applicationsObj);
  
      }
      if(Literature[i].literature_name == "reports"){
  
        FinancialTrendFund = FundName; 
        LiteratureTitle = Literature[i].title;
        LiteratureName = Literature[i].literature_name;
        FileName = Literature[i].file;
        LiteratureDate = Literature[i].date;
  
        reportsObj[LiteratureKeys[0]] = LiteratureName;
        reportsObj[LiteratureKeys[1]] = FileName;
        reportsObj[LiteratureKeys[2]] = LiteratureDate;
        reportsObj[LiteratureKeys[3]] = LiteratureTitle;
  
        reportsLiteratureArr.push(reportsObj);
  
      }
      if(Literature[i].literature_name == "offering_documents"){
  
        FinancialTrendFund = FundName; 
        LiteratureTitle = Literature[i].title;
        LiteratureName = Literature[i].literature_name;
        FileName = Literature[i].file;
        LiteratureDate = Literature[i].date;
  
        offerDocumentsObj[LiteratureKeys[0]] = LiteratureName;
        offerDocumentsObj[LiteratureKeys[1]] = FileName;
        offerDocumentsObj[LiteratureKeys[2]] = LiteratureDate;
        offerDocumentsObj[LiteratureKeys[3]] = LiteratureTitle;
  
        offerDocumentsLiteratureArr.push(offerDocumentsObj);
  
      }
  
      
      }
   
    }
  
  
    setFundNameState(FinancialTrendFund);
    setLiteratureDataState(OtherInfoLiteratureArr);
    setKeyInveInfoState(KeyInveInfoLiteratureArr);
    setPressCoverageState(pressCoverageLiteratureArr);
    setApplicationsState(applicationsLiteratureArr);
    setReportsState(reportsLiteratureArr);
    setofferDocumentState(offerDocumentsLiteratureArr);
  
  
  
  
  
  
  }

  // function Auth_User(){
  //   console.log("XYYYYYYYYYYYYYYYYYYYYYYYZ")
  //  var email;
  //  var arrAuthUser = [];
   
  //   for(let i=0;i< UserResponse.length;i++){
  //     let obj={};
  //     var Auth_Keys=["email"];
  //       // heading = UserResponse[i].heading;
  //       // objective = UserResponse[i].objective_content;  
      
  //       email = UserResponse[i].email ;
        
  //        console.log(email);
  //        console.log("Session DATA AUTH USER");
  //       obj[Auth_Keys[0]] = email ;

  //       if(obj.email == SessionUserResponse){
  //         console.log(obj.email);
  //         console.log("IF obj.email");

  //         return true;
          
  //     }else {
  //       console.log(obj.email);
  //       console.log("obj.email");
  //       console.log(SessionUserResponse);
  //       console.log("SessionUserResponse");



        
  //       console.log("ELSE obj.email");

  //       return false;
  //     }     
  //       }
    
  //   }
  const tt=()=>{
    // alert("hi");
    $('.btn-setting')[0].click();
  }
const summaryButton=()=>{
  // if(Auth_User()){

  let arrPRTU=[]
  tt();
  var heading;
  var objective;
  var team;

  for(let i=0 ; i< Summary.length ;i++){
    // typeof(products[i][j])
    if(Summary[i].heading== "ss_next_gen_pcc"){
      heading = Summary[i].heading;
      objective = Summary[i].objective_content;  
      team = Summary[i].team_content ;
      
      
      }     
     
  }
// For loop for calculation date
let calculation = RespPrtu[1][2]
let daily_cal = PRTU[9][1]

// new Date(date).toLocaleDateString()


let calculatedDate = new Date(calculation).toLocaleDateString("en-US", { day: 'numeric' })+ "/"+ new Date(calculation).toLocaleDateString("en-US", { month: 'numeric' })+ "/" + new Date(calculation).toLocaleDateString("en-US", { year: 'numeric' });



let DailycalculatedDate = new Date(daily_cal).toLocaleDateString("en-US", { day: 'numeric' })+ "/"+ new Date(daily_cal).toLocaleDateString("en-US", { month: 'numeric' })+ "/" + new Date(daily_cal).toLocaleDateString("en-US", { year: 'numeric' });
 
  var allKeys = ["name","current month","EFG","Price","ABC","XYZ","HIJ","currency","zero","test","classDetails","symbol","b","class"];
  
  // var length =  products.length-1;
 

    for(let i=9 ; i< PRTU.length ;i++){
      // typeof(products[i][j])
      
      let obj={};
      for(let j =0 ;j< PRTU[i].length ;j++){
  
        if(!isNaN(PRTU[i][j])){
        let val = PRTU[i][j];
        // var numb= 212421434.533423131231;
        var rounded2 = Math.round((val + Number.EPSILON) * 100) / 100;
  
      
        obj[allKeys[j]] = rounded2 ;
  
      }
       
        else{
          obj[allKeys[j]] = PRTU[i][j] ;
          obj[allKeys[0]] = PRTU[i][0] ;

          obj[allKeys[3]] = PRTU[i][3] ;
          obj[allKeys[8]] = PRTU[i][5] ;


        }     
  
        }
        if(obj.XYZ == "GBP"){
          obj[allKeys[11]] = "£";
        }else if(obj.XYZ == "EUR"){
          
          obj[allKeys[11]] = "€";
  
        }else if(obj.XYZ == "USD"){
          obj[allKeys[11]] = "$";
  
        }else if(obj.XYZ == "CHF"){
          obj[allKeys[11]] = "CHF";
  
        }else if(obj.XYZ == "CNH"){
          obj[allKeys[11]] = "¥";
  
        }
        var objectName = obj.name +'';
        var classShares = objectName.split("-");
    
        obj[allKeys[13]] = classShares[1];
        // obj[allKeys[8]] = classCurrency[1];
        
      
  
        arrPRTU.push(obj)
  
  }

 


  setarrPRTUState(arrPRTU)
  setPRTUDate(calculatedDate)
  setDailyDate(DailycalculatedDate)
  setSessionUserResponse(SessionResponse)

  setHeadingState(heading)
  setObjectiveState(objective)
  setTeamState(team)
  if (!arrPRTU.length > 0) {

      
    $(".daily-price-row").css("display","none") 
  }else{
    $(".daily-price-row").css("display","block")
  }
  if(!team) {
  
    $(".investment-team-row").css("display","none") 
  
  }  
  // }
  // else{
    
  //     window.location = config.apiPath+"/login_user";
  // }
  $('.footer-container').addClass('footer-container-line')

}
// $( document ).ready(function() {
    
//   if (!arrPRTUState.length > 0) {

    
//     $(".daily-price-row").css("display","none") 
//   }
//   });

const portfolioButton=()=>{

  const graphDataResponse = []
  const graphDataResponse1 = []
  const graphDataResponse12 = []
  const graphDataResponse123 = []
  const graphDataResponse2 = []

  const top10HoldingData =[]
  const marketCapData =[]
  const equitiesData =[]
  const DerVarData = []

  const sectorBreakdownData =[]
  const RegionbreakdownArray =[] 
  const sectorbreakdownArray =[]  
  
  const PortfolioStatArray =[]  
  const FXExposureArray =[]
  const NFAarr =[]  
  

  // const fundInfoData =[]

  var allKeys = ["name","current month","pevious month"];
  

  // for(let i=1 ; i< products.length ;i++){
  //   // typeof(products[i][j])
    
  //   let obj={};
  //   for(let j =0 ;j< products[i].length ;j++){

  //     if(!isNaN(products[i][j])){
  //     let val = products[i][j];
  //     // var numb= 212421434.533423131231;
  //     var rounded2 = Math.round((val + Number.EPSILON) * 100) / 100;

  //     console.log(rounded2);
  //     obj[allKeys[j]] = rounded2 ;

  //   }
  //     // var updatedVal =  parseFloat(val).toFixed(2);
  //     // console.log(updatedVal);
  //     else{
  //       obj[allKeys[j]] = products[i][j] ;
  //     }     

  //     }

  //     graphDataResponse.push(obj)
  //     // setTimeout()
      

  //     // console.log(graphData);
  //     // console.log("allKeys")

      
  // }

  var keysVAR = ["name", "value"]
  var length =AssetAllocation.length - 0;
   for(let i=1 ; i< length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< AssetAllocation[i].length ;j++){

      if(!isNaN(AssetAllocation[i][j])){
      let val = AssetAllocation[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;

    
      obj[keysVAR[j]] = rounded1 ;

    }

     
      else{

        obj[keysVAR[j]] = AssetAllocation[i][j] ;
      }     

      } 
      if(obj.value !==0){
        graphDataResponse1.push(obj)

      }

      
  }

  var keysCRE = ["name", "value"]
  var length = CreditRating.length;
   for(let i=1 ; i< length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< CreditRating[i].length ;j++){

      if(!isNaN(CreditRating[i][j])){
      let val = CreditRating[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;

 
      obj[keysCRE[j]] = rounded1 ;

    }


      else{

        obj[keysVAR[j]] = CreditRating[i][j] ;
      }     

      } 
      if(obj.value !==0){
        graphDataResponse2.push(obj)

      }
 
      
  }
  
  var keysRegionBreakdown = ["name", "value"]
  var length =productRegionBreakdown.length-1;
  for(let i=1 ; i< length ;i++){
   // typeof(products[i][j])
   
   let obj={};
   for(let j =0 ;j< productRegionBreakdown[i].length ;j++){

     if(!isNaN(productRegionBreakdown[i][j])){
     let val = productRegionBreakdown[i][j]*100;
     
     // var numb= 212421434.533423131231;
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

   
     obj[keysRegionBreakdown[j]] = rounded+'%' ;

   }

    
     else{
       obj[keysRegionBreakdown[j]] = productRegionBreakdown[i][j] ;
     }     

     }

     if(obj.value !==0 && obj.value !==0+'%'){
      RegionbreakdownArray.push(obj)
    }
     
   
     
 
   
 } 


 var keysVAR112 = ["name", "value","a","b"]
 var length =productRegionBreakdown.length-1;
   for(let i=1 ; i< length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< productRegionBreakdown[i].length ;j++){

      if(!isNaN(productRegionBreakdown[i][j])){
      let val = productRegionBreakdown[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;


      obj[keysVAR112[j]] = rounded1 ;

    }

   
   
      else{

        obj[keysVAR112[j]] = productRegionBreakdown[i][j] ;
      }     

      } 
      if(obj.value !==0){
        graphDataResponse12.push(obj)

      }
 
    }

 
   var keysPortfolioStat = ["name", "value"]
  
  for(let i=1 ; i< PortfolioStat.length ;i++){
   // typeof(products[i][j])
   
   let obj={};
   for(let j =0 ;j< PortfolioStat[i].length ;j++){
    if(i<4){

     if(!isNaN(PortfolioStat[i][j])){
     let val = PortfolioStat[i][j]*100;
     
     // var numb= 212421434.533423131231;
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;


     obj[keysPortfolioStat[j]] = rounded+'%' ;

   }
     else{
       obj[keysPortfolioStat[j]] = PortfolioStat[i][j] ;
     }
    }else{

      if(!isNaN(PortfolioStat[i][j])){
        let val = PortfolioStat[i][j]
        var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
        obj[keysPortfolioStat[j]] = rounded ;
   
      }
        else{
          obj[keysPortfolioStat[j]] = PortfolioStat[i][j] ;
        }


    }      

     }

     if(obj.value !==0 && obj.value !==0+'%'){
      PortfolioStatArray.push(obj)
    }
     
   
     
     
   
 } 

 const keysFXExposureStat = ["name", "value"];
for (let i = 1; i < FxFwdExpStat.length; i++) {
  const row = FxFwdExpStat[i];
  const obj = {};
  row.forEach((cell, j) => {
    let value = cell;
    if (!isNaN(value)) {
      value = Number(value); // Ensure it's a number
      // Multiply by 100 and format as percentage if i < 9
      if (i < 9) {
        value *= 100;
        value = (Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2) + '%';
      } else {
        value = Math.round((value + Number.EPSILON) * 100) / 100;
      }
    }

    obj[keysFXExposureStat[j]] = value;
  });

  // Filter out zero values
  if (obj.value !== 0 && obj.value !== '0.00%') {
    FXExposureArray.push(obj);
  }
}


 var keysNFA = ["name", "value"]
  
 for(let i=1 ; i< NFAData.length-1 ;i++){
  // typeof(products[i][j])
  
  let obj={};
  for(let j =0 ;j< NFAData[i].length ;j++){

    if(!isNaN(NFAData[i][j])){
    let val = NFAData[i][j]*100;
    
    // var numb= 212421434.533423131231;
    var rounded = Math.round((val + Number.EPSILON) * 100) / 100;


    obj[keysNFA[j]] = rounded+'%' ;

  }

    else{
      obj[keysPortfolioStat[j]] = NFAData[i][j] ;
    }     

    }

    if(obj.value !==0 && obj.value !==0+'%'){
      NFAarr.push(obj)
   }
    
  
    
  
  
} 


var keysVAR11 = ["name", "value","a","b"]
  var length =NFAData.length-1;
   for(let i=1 ; i< length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< NFAData[i].length ;j++){

      if(!isNaN(NFAData[i][j])){
      let val = NFAData[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;


      obj[keysVAR11[j]] = rounded1 ;

    }

      // var updatedVal =  parseFloat(val).toFixed(2);
      // console.log(updatedVal);
      else{

        obj[keysVAR11[j]] = NFAData[i][j] ;
      }     

      }
      if(obj.value !==0 && obj.value !==0+'%'){
        graphDataResponse123.push(obj)
      }
 
    }
 



  
  // setgraphData(graphDataResponse)
  setgraphData(graphDataResponse1)
  setregionBreakdown1(graphDataResponse12);
  setnetForeignA(graphDataResponse123);
  setportfolioStatusState(PortfolioStatArray)
  setFXExposureState(FXExposureArray)
  setNFAState(NFAarr)
  // setAssetAllocationState()
  settop10HoldingState(top10HoldingData)
  setmarketCapState(marketCapData)
  setequititeState(equitiesData)
  setDerVarState(DerVarData)


  setregionBreakdownState(RegionbreakdownArray)
  setsectorBreakdownState(sectorbreakdownArray)

  setgraphDataSectorPer(graphDataResponse2)




  
  
  
  setportfolioStatus(true)





}
const label = monthlyPerf[0]?.[1]; // e.g. "NAV per Share"
const values = monthlyPerf.slice(1).map(row => row[1]); // all values from second column, skipping header



  //const values = monthlyPerf.slice(0).map(row => row[1]); // Get all NAV values (2nd column only)



const performanceButton=()=>{


  const CummulativeperformanceData = []
  const CummulativeperformanceDUSDData = []
  const CummulativeperformanceDEURData =[]
  const CummulativeperformanceAEURData = []
  const CummulativeperformanceDGBPData =[]
  const CummulativeperformanceXCHFData = []
  const CummulativeperformanceBEURData = []
  const CummulativeperformanceCData = []

  const TwelveMperfAGBP = []
  const TwelveMperfDUSD = []
  const TwelveMperfAEUR = []
  const TwelveMperfDGBP = []
  const TwelveMperfDEUR = []
  const perfSummaryArr =  []
  const TwelveMperfGGBP = []

  const TwelveMperfBGBP = []
  const TwelveMperfBEUR = []
  const TwelveMperfCGBP = []
  

  const Bot3contriData = []
  const Top3contriData = []
  const InceptionDataArray =[]
  // const TwelvemonPerfData = []
   var monthsArr=[];






  for(let i= 7; i<=21;i++ ){
    monthsArr.push(productsMonthlyPerf[3][i])
  }


  var arr2D=[];
  for(let i=4 ;i<=11;i++){
    let arr=[]
    for(let j=8 ;j<=21;j++){
      if(productsMonthlyPerf[i][j] != ""){
     let val = productsMonthlyPerf[i][j]*100;
     
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
     rounded = parseFloat(rounded).toFixed(2);
     if(rounded ==0.00){
      rounded = 0;
    }

     if(isNaN(rounded)){
      rounded = 0;
      

    }
    //arr.push(rounded+'%')
      arr.push(rounded +'%')
    }else{
      if(productsMonthlyPerf[i][j] === 0){
        let val1 = productsMonthlyPerf[i][j]*100;
         var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
         rounded1 = parseFloat(rounded1).toFixed(2);
          if(rounded1 ==0.00){
            rounded1 = 0;
            arr.push(rounded1+'%')
          }
        }else{
            rounded = ''; 
            arr.push(rounded)
        }
      // rounded = ''; 
      // arr.push(rounded)
    }
      
      // arr.push(productsMonthlyPerf[i][j])
    }
    arr2D.push(arr);
  }

for(let i =0;i<arr2D.length;i++){
for(let j =0 ; j< arr2D[0].length;j++){


  if(arr2D[i][j]==0+'%'){

      arr2D[i][j] = "0.00%"
  }else if(arr2D[i][j]==''){

      arr2D[i][j] = " "
  }
}

}









 

  var keysCummulativePer = ["name", "value"]
// const [productscommulativePerformanceQAUSD, setproductscommulativePerformanceQAUSD] = useState([]);
  
   for(let i=0 ; i< productscommulativePerformanceQAUSD.length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< productscommulativePerformanceQAUSD[i].length ;j++){

      if(!isNaN(productscommulativePerformanceQAUSD[i][j])){
      let val = productscommulativePerformanceQAUSD[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
      rounded =parseFloat(rounded).toFixed(2);
      obj[keysCummulativePer[j]] = rounded+'%' ;

    }


      else{
        obj[keysCummulativePer[j]] = productscommulativePerformanceQAUSD[i][j] ;
      }     

      }
      CummulativeperformanceData.push(obj)
      

  } 





  var keysCummulativePerDUSD = ["name", "value"]
// const [productscommulativePerformanceQAUSD, setproductscommulativePerformanceQAUSD] = useState([]);
  
   for(let i=0 ; i< productscommulativePerformanceQDUSD.length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< productscommulativePerformanceQDUSD[i].length ;j++){

      if(!isNaN(productscommulativePerformanceQDUSD[i][j])){
      let val = productscommulativePerformanceQDUSD[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
      rounded =parseFloat(rounded).toFixed(2);
    
      obj[keysCummulativePerDUSD[j]] = rounded+'%' ;

    }

      else{
        obj[keysCummulativePerDUSD[j]] = productscommulativePerformanceQDUSD[i][j] ;
      }     

      }
      CummulativeperformanceDUSDData.push(obj)
      

  } 


  var keysCummulativePerAEUR = ["name", "value"]
// const [productscommulativePerformanceQAUSD, setproductscommulativePerformanceQAUSD] = useState([]);
  
   for(let i=0 ; i< productscommulativePerformanceQAEUR.length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< productscommulativePerformanceQAEUR[i].length ;j++){

      if(!isNaN(productscommulativePerformanceQAEUR[i][j])){
      let val = productscommulativePerformanceQAEUR[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
      rounded =parseFloat(rounded).toFixed(2);
      obj[keysCummulativePerAEUR[j]] = rounded+'%' ;

    }

     
      else{
        obj[keysCummulativePerAEUR[j]] = productscommulativePerformanceQAEUR[i][j] ;
      }     

      }
      CummulativeperformanceAEURData.push(obj)
      

  } 

  
  var keysCummulativePerXCHF = ["name", "value"]
// const [productscommulativePerformanceQAUSD, setproductscommulativePerformanceQAUSD] = useState([]);
  
   for(let i=0 ; i< productscommulativePerformanceXCHF.length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< productscommulativePerformanceXCHF[i].length ;j++){

      if(!isNaN(productscommulativePerformanceXCHF[i][j])){
      let val = productscommulativePerformanceXCHF[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
      rounded =parseFloat(rounded).toFixed(2);
      obj[keysCummulativePerXCHF[j]] = rounded+'%' ;

    }

      // var updatedVal =  parseFloat(val).toFixed(2);
      else{
        obj[keysCummulativePerXCHF[j]] = productscommulativePerformanceXCHF[i][j] ;
      }     

      }
      CummulativeperformanceXCHFData.push(obj)
      

  } 

  var keysCummulativePerDEUR = ["name", "value"]
  // const [productscommulativePerformanceQAUSD, setproductscommulativePerformanceQAUSD] = useState([]);
    
     for(let i=0 ; i< productscommulativePerformanceQDEUR.length ;i++){
      // typeof(products[i][j])
      
      let obj={};
      for(let j =0 ;j< productscommulativePerformanceQDEUR[i].length ;j++){
  
        if(!isNaN(productscommulativePerformanceQDEUR[i][j])){
        let val = productscommulativePerformanceQDEUR[i][j]*100;
        
        // var numb= 212421434.533423131231;
        var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
        rounded =parseFloat(rounded).toFixed(2);
        obj[keysCummulativePerDEUR[j]] = rounded+'%' ;
  
      }
  
       
        else{
          obj[keysCummulativePerDEUR[j]] = productscommulativePerformanceQDEUR[i][j] ;
        }     
  
        }
        CummulativeperformanceDEURData.push(obj)
        
  
    } 



  var keysCummulativePerDGBP = ["name", "value"]
  // const [productscommulativePerformanceQAUSD, setproductscommulativePerformanceQAUSD] = useState([]);
    
     for(let i=0 ; i< productscommulativePerformanceQDGBP.length ;i++){
      // typeof(products[i][j])
      
      let obj={};
      for(let j =0 ;j< productscommulativePerformanceQDGBP[i].length ;j++){
  
        if(!isNaN(productscommulativePerformanceQDGBP[i][j])){
        let val = productscommulativePerformanceQDGBP[i][j]*100;
        
        // var numb= 212421434.533423131231;
        var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
        rounded =parseFloat(rounded).toFixed(2);
        obj[keysCummulativePerDGBP[j]] = rounded+'%' ;
  
      }
  
        // var updatedVal =  parseFloat(val).toFixed(2);
        else{
          obj[keysCummulativePerDGBP[j]] = productscommulativePerformanceQDGBP[i][j] ;
        }     
  
        }
        CummulativeperformanceDGBPData.push(obj)
        
  
    } 


          var keys12monthsDis = ["name", "value"]

          for(let i=0 ; i< twelvemonPerfAGBP.length ;i++){
           // typeof(products[i][j])
          
           let obj={};
           for(let j =0 ;j< twelvemonPerfAGBP[i].length ;j++){

             if(!isNaN(twelvemonPerfAGBP[i][j])){
             let val = twelvemonPerfAGBP[i][j]*100;

             // var numb= 212421434.533423131231;
             var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
             rounded =parseFloat(rounded).toFixed(2);
             obj[keys12monthsDis[j]] = rounded+'%' ;

           }
         
             // var updatedVal =  parseFloat(val).toFixed(2);
             else{
               obj[keys12monthsDis[j]] = twelvemonPerfAGBP[i][j] ;
             }     
           
             }
           
             TwelveMperfAGBP.push(obj)
            
          } 

          var keys12monthsDisD = ["name", "value"]

          for(let i=0 ; i< twelvemonPerfDUSD.length ;i++){
           // typeof(products[i][j])
          
           let obj={};
           for(let j =0 ;j< twelvemonPerfDUSD[i].length ;j++){

             if(!isNaN(twelvemonPerfDUSD[i][j])){
             let val = twelvemonPerfDUSD[i][j]*100;

             // var numb= 212421434.533423131231;
             var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
             rounded =parseFloat(rounded).toFixed(2);
             obj[keys12monthsDisD[j]] = rounded+'%' ;

           }
         
             // var updatedVal =  parseFloat(val).toFixed(2);
             else{
               obj[keys12monthsDisD[j]] = twelvemonPerfDUSD[i][j] ;
             }     
           
             }
           
             TwelveMperfDUSD.push(obj)
            
          } 
          
          
          var keys12monthsDisAEUR = ["name", "value"]

          for(let i=0 ; i< twelvemonPerfAEUR.length ;i++){
           // typeof(products[i][j])
          
           let obj={};
           for(let j =0 ;j< twelvemonPerfAEUR[i].length ;j++){

             if(!isNaN(twelvemonPerfAEUR[i][j])){
             let val = twelvemonPerfAEUR[i][j]*100;

             // var numb= 212421434.533423131231;
             var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
             rounded =parseFloat(rounded).toFixed(2);
             obj[keys12monthsDisAEUR[j]] = rounded+'%' ;

           }
         
             // var updatedVal =  parseFloat(val).toFixed(2);
             else{
               obj[keys12monthsDisAEUR[j]] = twelvemonPerfAEUR[i][j] ;
             }     
           
             }
           
             TwelveMperfAEUR.push(obj)
            
          } 
          
          
          // twelvemonPerfDEUR
          var keys12monthsDisDEUR = ["name", "value"]

          for(let i=0 ; i< twelvemonPerfDEUR.length ;i++){
           // typeof(products[i][j])
          
           let obj={};
           for(let j =0 ;j< twelvemonPerfDEUR[i].length ;j++){

             if(!isNaN(twelvemonPerfDEUR[i][j])){
             let val = twelvemonPerfDEUR[i][j]*100;

             // var numb= 212421434.533423131231;
             var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
             rounded =parseFloat(rounded).toFixed(2);
             obj[keys12monthsDisDEUR[j]] = rounded+'%' ;

           }
         
             // var updatedVal =  parseFloat(val).toFixed(2);
             else{
               obj[keys12monthsDisDEUR[j]] = twelvemonPerfDEUR[i][j] ;
             }     
           
             }
           
             TwelveMperfDEUR.push(obj)
            
          } 
                    
          var keys12monthsDisDGGBP = ["name", "value"]

          for(let i=0 ; i< twelvemonPerfGGBP.length ;i++){
           // typeof(products[i][j])
          
           let obj={};
           for(let j =0 ;j< twelvemonPerfGGBP[i].length ;j++){

             if(!isNaN(twelvemonPerfGGBP[i][j])){
             let val = twelvemonPerfGGBP[i][j]*100;

             // var numb= 212421434.533423131231;
             var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
             rounded =parseFloat(rounded).toFixed(2);
             obj[keys12monthsDisDGGBP[j]] = rounded+'%' ;

           }
         
             // var updatedVal =  parseFloat(val).toFixed(2);
             else{
               obj[keys12monthsDisDGGBP[j]] = twelvemonPerfGGBP[i][j] ;
             }     
           
             }
           
             TwelveMperfGGBP.push(obj)
            
          } 
          // twelvemonPerfDGBP
          var keys12monthsDisDGBP = ["name", "value"]

          for(let i=0 ; i< twelvemonPerfDGBP.length ;i++){
           // typeof(products[i][j])
          
           let obj={};
           for(let j =0 ;j< twelvemonPerfDGBP[i].length ;j++){

             if(!isNaN(twelvemonPerfDGBP[i][j])){
             let val = twelvemonPerfDGBP[i][j]*100;

             // var numb= 212421434.533423131231;
             var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
             rounded =parseFloat(rounded).toFixed(2);
             obj[keys12monthsDisDGBP[j]] = rounded+'%' ;

           }
         
             // var updatedVal =  parseFloat(val).toFixed(2);
             else{
               obj[keys12monthsDisDGBP[j]] = twelvemonPerfDGBP[i][j] ;
             }     
           
             }
           
             TwelveMperfDGBP.push(obj)
            
          } 


       


  setcummulatovePerfData(CummulativeperformanceData)
  setcummulatovePerfDUSDData(CummulativeperformanceDUSDData)
  setcummulatovePerfAEURData(CummulativeperformanceAEURData)
  setCummulativeperfDEURData(CummulativeperformanceDEURData)
  setCummulativeperfDGBPData(CummulativeperformanceDGBPData)
  setCummulativeperXCHFArrData(CummulativeperformanceXCHFData)
  
  setTwelveMperfAGBPState(TwelveMperfAGBP)
  setTwelveMperfDUSDState(TwelveMperfDUSD)
  setTwelveMperfDGBPState(TwelveMperfDGBP)
  setTwelveMperfDEURState(TwelveMperfDEUR)
  setTwelveMperfAEURState(TwelveMperfAEUR)
  setTwelveMperfGGBPState(TwelveMperfGGBP)
  setPerformanceSummaryState(perfSummaryArr)
  
  

  // setcummulatovePerfBData(CummulativeperformanceBData)
   setmonthlyPerformance2DArrayState(arr2D)
   setmonthsArrayState(monthsArr)
//   setCummulativeperfeBEURData(CummulativeperformanceBEURData)
  




}


const informationButton=()=>{
  const shareClassData =[]
  const fundInfoData =[]
  const CMSfundInfoData =[]
  const CMSshareInfoData =[]

  
  var keysCMSshareinfo = ["name", "ausdValue","agbpValue","aeurValue","busdValue","bgbpValue","beurValue","cgbpValue"]
  
  for(let j =0 ;j< CMSshareinfo.length ;j++){


   let obj={};

      obj[keysCMSshareinfo[0]] = CMSshareinfo[j].title ;
      obj[keysCMSshareinfo[1]] = CMSshareinfo[j].ausd_value ;
      obj[keysCMSshareinfo[2]] = CMSshareinfo[j].agbp_value ;
      obj[keysCMSshareinfo[3]] = CMSshareinfo[j].aeur_value ;
      obj[keysCMSshareinfo[4]] = CMSshareinfo[j].busd_value ;
      obj[keysCMSshareinfo[5]] = CMSshareinfo[j].bgbp_value ;
      obj[keysCMSshareinfo[6]] = CMSshareinfo[j].beur_value ;
      obj[keysCMSshareinfo[7]] = CMSshareinfo[j].cgbp_value ;



    CMSshareInfoData.push(obj)
  }

  var keysCMSFundinfo = ["name", "value"]
  
  for(let j =0 ;j< CMSFundinfo.length ;j++){
  

   let obj={};

   // KeyInveInfoObj[LiteratureKeys[0]] = LiteratureName;

      obj[keysCMSFundinfo[0]] = CMSFundinfo[j].title ;
      obj[keysCMSFundinfo[1]] = CMSFundinfo[j].value ;
    


    CMSfundInfoData.push(obj)
    }

  var keysShareClass = ["name", "value"]
  
  for(let i=0 ; i< productsShareClass.length ;i++){
   // typeof(products[i][j])
   
   let obj={};
   for(let j =0 ;j< productsShareClass[i].length ;j++){

     if(!isNaN(productsShareClass[i][j])){
     let val = productsShareClass[i][j];
     
     // var numb= 212421434.533423131231;
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

   
     obj[keysShareClass[j]] = rounded.toString().replace(/(^\d{1,3}|\d{3})(?=(?:\d{3})+(?:$|\.))/g, '$1,') ;
 
   }

     // var updatedVal =  parseFloat(val).toFixed(2);
     // console.log(updatedVal);
     else{
       obj[keysShareClass[j]] = productsShareClass[i][j] ;
     }     

     }
     shareClassData.push(obj)
   
     
 }  


  var keysFundinfo = ["name", "value"]
  
  for(let i=1 ; i< productsFundinfo.length ;i++){
   // typeof(products[i][j])
   
   let obj={};
   for(let j =0 ;j< productsFundinfo[i].length ;j++){

     if(!isNaN(productsFundinfo[i][j])){
     let val = productsFundinfo[i][j]*100;
     
     // var numb= 212421434.533423131231;
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

   
     obj[keysFundinfo[j]] = rounded.toString().replace(/(^\d{1,3}|\d{3})(?=(?:\d{3})+(?:$|\.))/g, '$1,') ;

   }

    
     else{
       obj[keysFundinfo[j]] = productsFundinfo[i][j] ;
     }     

     }
     fundInfoData.push(obj)
   

 }

 setShareClassarray(shareClassData)
 setFundinfoarray(fundInfoData)

 setCMSFundinfoarray(CMSfundInfoData)
 setCMSshareinfoarray(CMSshareInfoData)









}









let AbcObject ={};

let count = 0;
async function fetchsessionAPI(){


  fetch(config.apiPath+'/session_data').then(resp => resp.json()).then(resp =>  {

  
    if(resp !== 0){

    
      // window.location = config.apiPath+"/login_user";
    }else{

            window.location = config.apiPath+"/login_user";


    }
    
  
  })

}
async function fetchMyAPI(){
  // fetchUserAPI();
  fetchSessionUserAPI();
// const fetchMyAPI = useCallback(() => {
  // https://epicipprojects.com/getdata  
  // https://jsonplaceholder.typicode.com/posts
  // const url ='https://epicipprojects.com/garraway-financial-trends';
  // const url = 'https://epicipprojects.com/api/ss-nfa-ucits'
  const Localurl = 'https://www.epicip.com/epic-next-gen-pcc'
  const url = config.apiPath+'/epic-next-gen-pcc' 
  // const url = 'https://www.epicip.com/epic-next-gen-pcc'
  //const url = 'http://127.0.0.1:8000/epic-next-gen-pcc'
  
  fetch(config.apiPath+'/session_data').then(resp => resp.json()).then(resp =>  {
  
  
    setSessionResponse(resp);
  
  
  })
   fetch(url).then(resp=> resp.json())
   .then (resp => {
 
    //console.log("fully" ,resp.Monthlyperf);
      setMonthlyPerf(resp.Monthlyperf);
    //  console.log('monthlyPerf data:', resp.Monthlyperf);

    setAssetAllocation(resp.Entitybreakdown)    
    setCreditRating(resp.Creditratingbreakdown)
    setproductscommulativePerformanceQAUSD(resp.CumulativePerfXUSD)
    setproductscommulativePerformanceQAEUR(resp.CumulativePerfXGBP)
    setproductscommulativePerformanceXCHF(resp.CumulativeXCHF)
    setproductscommulativePerformanceQDEUR(resp.CumulativePerfXEUR)
    setproductscommulativePerformanceQDGBP(resp.CumulativePerfUSDP)
    setproductscommulativePerformanceQDUSD(resp.CumulativePerfGBPP)

    settwelvemonPerfAGBP(resp.PerfdiscreateXUSD)
    settwelvemonPerfDUSD(resp.PerfdiscreateXGBP)
    settwelvemonPerfAEUR(resp.PerfdiscreateXCHF)
    settwelvemonPerfDEUR(resp.PerfdiscreateXEUR)
    settwelvemonPerfDGBP(resp.PerfdiscreateUSDP)
    
    settwelvemonPerfGGBP(resp.PerfdiscreateGBPP)


    setperformanceSummary(resp.perfsummary)
    

    // settwelvemonPerfBGBP(resp.twelvemPerfDiscreteclassflnc)
    // settop3response(resp.Top3Contributors)
    // setbot3response(resp.Bottom3Contributors)

    setproductsCommentary(resp.content)
    // setproductRegional(resp.RegionalWeightings)
    // setproductstop10Holding(resp.TopHoldings)

    // setproductsmarketCap(resp.FixedIncomeBreakdown)

    setproductRegionBreakdown(resp.Regionbreakdown)
    setPortfolioStat(resp.Portfoliostatistics)
    setFxFwdExpStat(resp.FxFwdExp)
    
    setNFAData(resp.Nfabreakdown)

    setproductSectorBreakdown(resp.EquitiesBreakdown)

    setproductsFundinfo(resp.Fundinfo)
    setproductsShareClass(resp.Fundprice)
   
    //setproductsMonthlyPerf(resp.MonthlyPerf)
    setproductsMonthlyPerf(resp.Inceptionperfdata)
    // setLoading(true)
    setRespPrtu(resp.Prtu)
    setPRTU(resp.daily_price)
   

    setLiterature(resp.literature)
    setSummary(resp.summary)
    setCMSFundinfo(resp.fund_info)
    setCMSshareinfo(resp.shareinfo)
    setStateSession(SessionResponse);



    // setLoading(true)
    setstatus(true)
    document.getElementById("summaryButton").click();

    //  }

    })
    
   .catch(e=>{
  
   })
  // setresponseData(result)
  // .then( resp=>console.log(resp.SectorExposures))
  
  // console.log(responseData)
  // console.log("responseData")

  var keysMonthly = ["name"]
  var testArr =[]
  var monthsValue =[[],[]]
  var xArr =[[]]
 
};

// const dat = useMemo(()=>(AbcObject),[])





const players =[
  {
    position:"forward",
    name:"Lebron",
    team:"Lakers"
  },
  {
    position:"forward",
    name:"Lebron",
    team:"Lakers"
  },
  {
    position:"forward",
    name:"Lebron",
    team:"Lakers"
  },
  {
    position:"forward",
    name:"Lebron",
    team:"Lakers"
  }
]

const cummulatovePerfDatadummy =[
  {
    "name" : "Class B GBP",
     "value" : "Cumulative Performance"
  },
  {
      "name": "1m",
      "value": -1.29
  },
  {
      "name": "1Yr",
      "value": 1.04
  },
  {
      "name": "3Yr",
      "value": -2.41
  },
  {
      "name": "5Yr",
      "value": -19.6

  },
  {
      "name": "Since UCITS Strategy Relaunch",
      "value": 19.08
  },
  {
      "name": "Since Inception",
      "value": -3.37
  }
]

const twelvemonPerfDatadummy =[
  {
    "name" : "Class B GBP",
    "value" : "Discrete Performance"
  },

  {
        "name": "30/06/2016 - 30/06/2017",
        "value": -5.09
    },
    {
        "name": "30/06/2017 - 30/06/2018",
        "value": -13.35
    },
    {
        "name": "30/06/2018 - 30/06/2019",
        "value": 2.26
    },
    {
        "name": "30/06/2019 - 30/06/2020",
        "value": -4.85
    },
    {
        "name": "30/06/2020 - 30/06/2021",
        "value": 3.5
    }
]

const top3contriDummy = [
  {
      "name": "Long ASX SPI 200 Index",
      "value": 0.41,
      "undefined": 100
  },
  {
      "name": "Long S&P 500 Index",
      "value": 0.33,
      "undefined": 200
  },
  {
      "name": "Short Australian Dollar / New Zealand Dollar",
      "value": 0.3,
      "undefined": 300
  }

]
async function fetchSessionUserAPI(){

  const Localurl = 'https://epicipprojects.com/session_data'
  const url = config.apiPath+'/session_data' 

   
   fetch(url).then(resp=> resp.json())
   .then (resp => {
     

     
      setSessionResponse(resp);

      // setSessionUserResponse(resp.email);
      // UserResponse SessionUserResponse  
    })
    
   .catch(e=>{

   })
};
async function fetchUserAPI(){
  
  const Localurl = 'https://epicipprojects.com/pcc_fund_user_data'
  const url = config.apiPath+'/pcc_fund_user_data' 
   
   fetch(url).then(resp=> resp.json())
   .then (resp => {
  


    // setUserResponse(resp)
      


    //  }

    })
    
   .catch(e=>{

   })
};

if ($(".accordion__item__header").length > 0) {
  
  var active = "active";
  var activedis = "active-dis";
  $(".accordion__item__header").on("click", function (event) {
    event.stopImmediatePropagation();
    $(this).toggleClass(active);
    $(this).find(".navlink").toggleClass(activedis);
    
  $(this).next("div").slideToggle(200);
  });
  }
  function renderDailyPrices(DailyPrice, index){
    if(DailyPrice.Price !== 0){
    return(
      <div class="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
        <div class="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">{DailyPrice.symbol}{parseFloat(DailyPrice.Price).toFixed(2)}</div>
        <div class="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">{DailyPrice.class}
        {/* <br/><span className="daily-span">(USD) Shares</span> */}
        </div>
    </div>
    )
  }else{
    return false
  }
  }
function renderLiteratureData(data, index){
  return(

              <div class="col-sm-6">
					      <p class="pdf_download"><a href={config.apiPath+"/storage/literature-file/"+data.FileName} download target="_blank">{data.LiteratureTitle}<br/><span class="date">{data.LiteratureDate}</span></a></p>
				      </div>
  )
}
function renderTop10Holding(holding, index) {
  return(
  <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
    <td>{holding.name}</td>
    <td>{holding.value}</td>

  </tr>
        
  
  )
}


function renderMarketState(market, index) {
  return(
  <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
    <td>{market.name}</td>
    <td>{market.value}</td>

  </tr>
        
  
  )
}

function renderSectorState(sector, index) {
  return(
  <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
    <td>{sector.name}</td>
    <td>{sector.value}</td>

  </tr>
        
  
  )
}










// productscommulativePerformance
function renderCummulativePerformanceNames(cummulatove, index) {
  if(index==0){
    return(


      <th>{cummulatove.value}</th>
)  
  }else{
  return(
      
        <th>{cummulatove.name}</th>
  
  )}
}
function renderCummulativePerformanceValue(cummulatove, index) {
  if(index==0){
    return(


      <td>{cummulatove.name}</td>
)  
  }else{
  return(


        <td>{cummulatove.value}</td>
  )}
}
function rendertwelvemonPerfDiscreteAPINames(twelvemon, index){
  return(
    <th>{twelvemon.name}</th>
)
}
function rendertwelvemonPerfDiscreteAPIValue(twelvemon, index){
  return(
    <th>{twelvemon.value}</th>
)
}

function rendertop3contri(top3contriparam, index){
  return(
    <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
      <td className="align-left" style={{height: "31.2px"}}>{top3contriparam.name}</td>
      <td  className="align-right" style={{height: "31.2px"}}>{top3contriparam.value}</td>
    </tr>
  )
}
function renderMonthNames(months, index){
    return(
  
      <th>{months}</th>
  )
  }
  
  function render12MonthsData(bot3contriparam, index){
    // alert(bot3contriparam.name);
  for( let i=0; i< bot3contriparam.length; i++){
    return(
      <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
        
        <td>{bot3contriparam[0].toString().slice(0,4)}</td>
        <td>{bot3contriparam[1]}</td>
        <td>{bot3contriparam[2]}</td>
        <td>{bot3contriparam[3]}</td>
        <td>{bot3contriparam[4]}</td>
        <td>{bot3contriparam[5]}</td>
        <td>{bot3contriparam[6]}</td>
        <td>{bot3contriparam[7]}</td>
        <td>{bot3contriparam[8]}</td>
        <td>{bot3contriparam[9]}</td>
        <td>{bot3contriparam[10]}</td>
        <td>{bot3contriparam[11]}</td>
        <td>{bot3contriparam[12]}</td>
        <td>{bot3contriparam[13]}</td>

  
  
        {/* <td>{bot3contriparam.value}</td> */}
      </tr>
    )
  }
  }

  function renderbot3contribution(bot3contriparam, index){
  // alert(bot3contriparam.name);
// Split the string using "-"
  const parts = bot3contriparam.name.split('-');
  return(
    <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ eVXooJ_newfact" key={index}>
      
      <td className="align-left" style={{height: "31.5px"}}>{parts[0]}</td>
      <td className="align-right" style={{height: "31.5px"}}>{bot3contriparam.value}</td>
    </tr>
  )
}

function renderbot3contri(bot3contriparam, index){
  // alert(bot3contriparam.name);

  return(
    <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ eVXooJ_newfact" key={index}>
      
      <td className="align-left" style={{height: "31.5px"}}>{bot3contriparam.name}</td>
      <td className="align-right" style={{height: "31.5px"}}>{bot3contriparam.value}</td>
    </tr>
  )
}
function renderCMSshareinfo(shareinfoparam, index){
  // alert(bot3contriparam.name);

  return(
    <tr className="Shares__Row-sc-1brks4f-2 eoQrEv" key={index}>
      
      <td className="align-left">{shareinfoparam.name}</td>
      <td className="align-center">{shareinfoparam.ausdValue}</td>
      <td className="align-center">{shareinfoparam.agbpValue}</td>
      <td className="align-center">{shareinfoparam.aeurValue}</td>
      <td className="align-center">{shareinfoparam.busdValue}</td>
      <td className="align-center">{shareinfoparam.bgbpValue}</td>
      <td className="align-center">{shareinfoparam.beurValue}</td>
      <td className="align-center">{shareinfoparam.cgbpValue}</td>
    
    </tr>
  )
}


function renderFundinfo(fundinfoparam, index){
  // alert(bot3contriparam.name);

  return(
    <tr className="FundInformation__Row-sc-18irt95-2 fweCQL" key={index}>
      
      <td className="align-left">{fundinfoparam.name}</td>
      <td className="align-center">{fundinfoparam.value}</td>
    </tr>
  )
}
function renderShareClassNames(shareClass, index){
 if(index==0){
  return(
    <th className="align-left">{shareClass.name}</th>
)}else{
  return(
    <th className="align-right">{shareClass.name}</th>
)
}
}
function renderShareClassValue(shareClassValue, index){
  if(index==0){
  return(
    <td className="align-left">{shareClassValue.value}</td>
)}else{
  return(
    <td className="align-right">{shareClassValue.value}</td>
) 
}
}


function previewData(formData) {

  /* Add return before formData.map */
  return formData.map((item, key) => {
  
     return (
      <td>{item.name}</td>

      //  <div>{item.value}</div>
     )
   })
 }







 

    return (
      <Fragment>

    { status === true ? 
    
<section className="main-box">
  <div className="container">
    <div className="row">
      <div className="col-lg-3 col-md-3 col-sm-4">
        <Sidebar StateSession={{StateSession:StateSession,"url":"EpicNextGenPCC","group":"Fixed Income"}}/>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-8 offset-md-1">
    <ul class="nav nav-tabs custom-nav-tabs" role="tablist">
      <li class="nav-item nav-item-tabs"> <a class="nav-link active" id="summaryButton" data-toggle="tab" href="#nine" onClick={summaryButton} role="tab">Summary</a> </li>
      <li class="nav-item nav-item-tabs"> <a class="nav-link" data-toggle="tab" href="#eight" onClick={portfolioButton} role="tab">Portfolio</a> </li>
      <li class="nav-item nav-item-tabs"> <a class="nav-link" data-toggle="tab" href="#one" onClick={performanceButton}  role="tab">Performance</a> </li>

      <li class="nav-item nav-item-tabs"> <a class="nav-link " data-toggle="tab" href="#two" role="tab">Commentary</a> </li>
     <li class="nav-item nav-item-tabs"> <a class="nav-link" data-toggle="tab" href="#three" onClick={informationButton}  role="tab">Information</a> </li>
     <li class="nav-item nav-item-tabs"> <a class="nav-link" data-toggle="tab" href="#four" id="literatureTab" onClick={literatureButton} role="tab">Literature</a> </li>  
    </ul>
    <div class="tab-content">
      <div class="tab-pane fade active show" id="nine" role="tabpanel">
        <div class="row">
          <div class="col-sm-12">
            <div role="tabpanel" aria-hidden="false" class="fade tab-pane active show">
               
                <div class="row">

                    
                
                    {/* <div role="tabpanel" aria-hidden="false" class="fade tab-pane active show"> */}
                        {/* <div classes="mb-1" class="row"> */}
                            <div class="col-md-12">
                            <div class="Paragraph__ParagraphContainer-sc-2ra4j2-0 gnBxSc">
                                    <div>                              

                                        {/* <h3 class="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">{HeadingState}</h3> */}
                                        <div class="Paragraph__NormalParagraph-sc-2ra4j2-1 dISjjZ" dangerouslySetInnerHTML={{ __html: ObjectiveState }}>
                                            
                                            {/* <p class="Paragraph__Body-sc-2ra4j2-4 gIzxtZ" dangerouslySetInnerHTML={{ __html: ObjectiveState }}>
                                                
                                            </p> */}
                                        </div>
                                    </div>
                                 
                                </div>
                            </div>
                        {/* </div> */}
                        <div class="row margin-1 daily-price-row">
                            <div class="col">
                                <div>
                                    <h3 class="Paragraph__Heading-sc-2ra4j2-2">Daily Prices</h3>
                                    <div class="DailyPricing__Boxes-sc-62f3gi-0 biswZj">
                                    {arrPRTUState.map(renderDailyPrices)}
                                        
                                    </div>
                                    <div class="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                                    <p className="mt-2">Data as at: {DailyDate}<br/>
                                        <span className="mt-1">Source: EPIC Markets (UK) LLP</span></p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row margin-1 investment-team-row">
                            <div class="col-md-12">
                                <h3 class="Paragraph__Heading-sc-2ra4j2-2">Investment Team</h3>
                                <p class="Paragraph__Body-sc-2ra4j2-4 gIzxtZ" dangerouslySetInnerHTML={{ __html: TeamState }}>

                                  </p>

                                
                            </div>
                            </div>
                            {/* </div> */}
                
                
                
                
                </div>
                </div>
                {/* <div class="row">
                    <div class="col">
                        <h3 class="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">Investment Team</h3>
                        <h3 class="Paragraph__SubHeading-sc-2ra4j2-3 dtCYUm">Mark Harris - Fund Manager</h3>
                        <p class="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">Mark is the lead Fund Manager of Garraway’s range of multi-asset funds. Mark joined Garraway in 2019 from City Financial where he headed the multi-asset team, joining in October 2012 as part of its acquisition of Eden Asset Management. He joined Eden in 2011 to head its multi-asset business. In 2009, he joined Henderson following its acquisition of New Star Asset Management, leading a team of six managing over £2 billion in assets across a range of low to high-risk mandates. He had previously spent six years at New Star Asset Management managing a range of award-winning funds. Mark has a degree in Law and Economics from Newcastle University.</p>
                        <h3 class="Paragraph__SubHeading-sc-2ra4j2-3 dtCYUm">Pushpanshu Prakash - Senior Investment Analyst</h3>
                        <p class="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">Pushpanshu joined Garraway in 2019 from City Financial where he was a fund analyst for the Multi Asset team responsible for fund specific research and quantitative modelling. He joined City Financial in 2017 after graduating from University College London (UCL) with an MSci in Mathematics, where he completed his thesis in fluid dynamics with a focus on situational modelling and financial mathematics. Prior to starting his career in financial services, he completed internships at the UCL School of Management, Atlantic Trading and Procter &amp; Gamble.</p>
                    </div>
                </div> */}

          </div>
          
        </div>
      </div>
      <div class="tab-pane fade" id="eight" role="tabpanel">

      



        <div class="row chart-row">
        <div class="col-md-6 chart-block">
            <p class="lse_redirect">Entity Breakdown (% NAV)</p>
            <PieChart width={340} height={330} margin ={ {top: -60, right: 50, bottom: 5, left: 0} } >
              <Pie
                data={graphData}
                cx={90}
                cy={200}
                innerRadius={45}
                outerRadius={90}
                paddingAngle={0}
                startAngle={90}
                endAngle={-330}
                dataKey="value"
                labelLine={false}
                label={renderCustomizedLabel}

              >
                {graphData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={DONUTCOLORS5[index % DONUTCOLORS5.length]} />
                ))}
              </Pie>
              <Tooltip />
              {/* <Legend /> */}
              
              <Legend margin={ {top:-500, left: -150} } className="legend-text" formatter={renderColorfulLegendText}  iconSize={10} width={300} height={50} layout='vertical' />
            </PieChart>
            
          
          </div>

          <div class="col-md-6 VARmargin chart-block"> 
            <p class="lse_redirect">Credit Rating Breakdown (% NAV)</p>
            <p class="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>
            
            <ResponsiveContainer width="100%" height="70%">
                
              <BarChart
                 width={600}
                 height={300}
                 data={graphDataSectorPer}
                 margin={{
                   top: 5,
                   right: 30,
                   left: 20,
                   bottom: 5
                 }}
                 layout="vertical"
               >
                 <CartesianGrid strokeDasharray="" horizontal="" vertical=""  />
                 <XAxis dataKey="value" type="number"  orientation="top" axisLine={false} tickFormatter={(tick) => {
                         return `${tick}%`;
                         }}
                  />
                 <YAxis type="category" dataKey="name"/>
                 <Tooltip />
                 {/* <Legend /> */}
                 <Bar dataKey="value" fill="BLACK" >
                 {
                          graphDataSectorPer.map((entry, index) => (
                            <Cell key={`cell-${index}`}  stroke={colors[index]}  strokeWidth={index === 2 ? 4 : 1} fill={colors[index % 20]}/>
                          ))
                        }
                        </Bar>
                 {/* <Bar dataKey="uv" fill="#82ca9d" /> */}
               </BarChart>
               </ResponsiveContainer>

          </div>
          <div class="col-md-6 chart-block"> 
          <p class="lse_redirect">Regional Breakdown</p>
            <p class="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>
            
                
            <PieChart width={340} height={330} margin ={ {top: -60, right: 50, bottom: 5, left: 0} } >
              <Pie
                data={regionBreakdown1}
                cx={90}
                cy={200}
                innerRadius={45}
                outerRadius={90}
                // fill="#0c2340"
                paddingAngle={0}
                startAngle={90}
                endAngle={-330}
                dataKey="value"
                labelLine={false}
                label={renderCustomizedLabelFixed}

              >
                {regionBreakdown1.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={DONUTCOLORS6[index % DONUTCOLORS6.length]} />
                ))}
              </Pie>
              <Legend margin={ {top:-500,} } className="legend-text" formatter={renderColorfulLegendText} iconSize={10} width={300} height={50} layout='vertical' />

              <Tooltip />
              {/* <Legend /> */}
            </PieChart>
          
          
          </div>
          <div class="col-md-6 VARmargin chart-block"> 
            <p class="lse_redirect">Net Foreign Assets Breakdown (% NAV)</p>
            <p class="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>
            
            <PieChart width={330} height={340} margin ={ {top: -60, right: 50, bottom: 5, left: 10} } >
              <Pie
                data={netForeignA}
                cx={90}
                cy={200}
                innerRadius={45}
                outerRadius={90}
                // fill="#0c2340"
                paddingAngle={0}
                startAngle={90}
                endAngle={-330}
                dataKey="value"
                labelLine={false}
                label={renderCustomized12LabelFixed}

              >
                {netForeignA.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={DONUTCOLORS7[index % DONUTCOLORS7.length]} />
                ))}
              </Pie>
              <Legend margin={ {top:-500,} } className="legend-text" formatter={renderColor12fulLegendText} iconSize={10} width={300} height={50} layout='vertical' />

              <Tooltip />
              {/* <Legend /> */}
            </PieChart>
            

             </div>
              <div class="row table-growth-row remove_margin">
              <div class="pl-md-1 col-12 col-md-4 col remove_margin">
                      {FXExposureState && FXExposureState.length > 0 && (
                        <table class="table  AssetClass__Table-sc-1rmhbx4-3 iiGyjE iiGyjE_dfm iiGyjE_dfmwidth">
                            <tbody class="AssetClass__Body-sc-1rmhbx4-4 cyhKrw">
                            <tr class="AssetClass__Row-sc-1rmhbx4-5 eVXooJ eVXooJ_new">
                                <th className="align-left" style={{width: "65%"}}>FX Exposure</th>
                                    <th className="align-right" style={{width: "30%"}}>(% NAV)</th>
                                </tr>
                                {FXExposureState.map(renderbot3contribution)}
                                

                            </tbody>
                        </table>
                      )}
                    </div>
            </div>
          <div class="row table-growth-row remove_margin">
            {/*<div class="pr-md-1 col-12 col-md-4 col table-div-margin remove_margin">
                        <table class="table  AssetClass__Table-sc-1rmhbx4-3 iiGyjEGR iiGyjEGR_dfm">
                            <tbody class="AssetClass__Body-sc-1rmhbx4-4 cyhKrw">
                                <tr class="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
                                <th className="align-left" style={{width: "65%"}}>Regional Breakdown</th>
                                    <th className="align-right" style={{width: "30%"}}>(% NAV)</th>
                                </tr>
                                {/* <tr class="AssetClass__Row-sc-1rmhbx4-5 eVXooJ"> */}
                                {/* {top3contriarray.map(rendertop3contri)} */}
                                
                               {/* {regionBreakdownState.map(rendertop3contri)} */}

                                {/* </tr> */}
                                {/* <tr class="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
                                    <td>Long ASX SPI 200 Index</td>
                                    <td>0.41%</td>
                                </tr>
                                <tr class="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
                                    <td>Long S&amp;P 500 Index</td>
                                    <td>0.33%</td>
                                </tr>
                                <tr class="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
                                    <td>Short Australian Dollar / New Zealand Dollar</td>
                                    <td>0.30%</td>
                                </tr> */}
                           {/* </tbody>
                        </table>
                              </div>*/}


                    <div class="pl-md-1 col-12 col-md-4 col remove_margin">

                        <table class="table  AssetClass__Table-sc-1rmhbx4-3 iiGyjE iiGyjE_dfm">
                            <tbody class="AssetClass__Body-sc-1rmhbx4-4 cyhKrw">
                                <tr class="AssetClass__Row-sc-1rmhbx4-5 eVXooJ eVXooJ_new">
                                <th className="align-left" style={{width: "65%"}}>Portfolio Statistics</th>
                                    <th className="align-right" style={{width: "30%"}}>(% NAV)</th>
                                </tr>
                                {portfolioStatusState.map(renderbot3contri)}
                                

                            </tbody>
                        </table>
                    </div>


                   {/* <div class="pl-md-1 col-12 col-md-4 col remove_margin">

                      <table class="table  AssetClass__Table-sc-1rmhbx4-3 iiGyjE iiGyjE_dfm_otherOne">
                          <tbody class="AssetClass__Body-sc-1rmhbx4-4 cyhKrw">
                          <tr class="AssetClass__Row-sc-1rmhbx4-5 eVXooJ eVXooJ_newch">
                                  <th style={{width: "65%"}} className="align-left">Net Foreign Assets Breakdown</th>
                                  <th style={{width: "25%"}} className="align-right">(% NAV)</th>
                              </tr>
                              {NFAState.map(renderbot3contri)}


                          </tbody>
                      </table>
                            </div>*/}
                </div>
        </div>

        <div class="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                     <p className="mt-2 i">Monthly data as at: {PRTUDate}. 
                     All information also available to download <a href={config.apiPath+"/sitepdfs/epic_next_gen_pcc.pdf"} target="_blank">here</a>
                      <br/></p>
                  </div>



      </div>
      
      <div class="tab-pane fade" id="one" role="tabpanel">
        <div class="row">
          
          <div class="col-sm-12">
            <div role="tabpanel" aria-hidden="false" class="fade tab-pane active show">

            <div class="row">
                    <div class="col" >

                    <table class=" table  CumulativePerformance__Table-sc-51pab9-0 hRUkzz">
                            <tbody>
                                <tr class="CumulativePerformance__TopRow-sc-51pab9-1 dwdfBh dwdfBh_new">
                                  
                                  {cummulatovePerfData.map(renderCummulativePerformanceNames)}

                                </tr>
                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
              
                                  {cummulatovePerfData.map(renderCummulativePerformanceValue)}

                                </tr>
              
                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
              
                                  {cummulatovePerfAEURData.map(renderCummulativePerformanceValue)}

                                </tr>
                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
              
                                  {CummulativeperXCHFArrData.map(renderCummulativePerformanceValue)}

                                </tr>
                                

                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
              
                                  {CummulativeperfDEURData.map(renderCummulativePerformanceValue)}

                                </tr>
                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
              
                                  {CummulativeperfDGBPData.map(renderCummulativePerformanceValue)}

                                </tr>
                                
                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
              
                                  {cummulatovePerfDUSDData.map(renderCummulativePerformanceValue)}

                                </tr>                  
                                
                                
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="mb-2 row">
                    <div class="col" >
                    <table class=" table  CumulativePerformance__Table-sc-51pab9-0 hRUkzz hRUkzz_dfm_new">
                            <tbody>
                                <tr class="CumulativePerformance__TopRow-sc-51pab9-1 dwdfBh">
                                  {TwelveMperfAGBPState.map(renderCummulativePerformanceNames)}

                                </tr>
                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
              
                                  {TwelveMperfAGBPState.map(renderCummulativePerformanceValue)}

                                </tr>
                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                  {TwelveMperfDUSDState.map(renderCummulativePerformanceValue)}

                                </tr>
                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                  {TwelveMperfAEURState.map(renderCummulativePerformanceValue)}

                                  </tr>
                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                  {TwelveMperfDEURState.map(renderCummulativePerformanceValue)}

                                </tr>                                
                                <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                  {TwelveMperfDGBPState.map(renderCummulativePerformanceValue)}

                                  </tr>
                                  <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {TwelveMperfGGBPState.map(renderCummulativePerformanceValue)}

                                  </tr>
                                  


                                
                                
                            </tbody>
                        </table>
                    </div>
                </div>


                <div class="mb-2 row">
                    <div class="col" >
                        <div class="MonthlyPerformance__Wrapper-sc-1n33bhd-0 cHAvbZ">
                        <table class=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                <tbody class="MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    {/* <tr>
                                        <th colspan="99" class="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                            Performance Summary</th>
                                    </tr> */}
                                    <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                      {PerformanceSummaryState.map(renderCummulativePerformanceNames)}

                                      </tr>
                                    
                                </tbody>
                            </table>

                            <table class=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                <tbody class="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    <tr>
                                        <th colspan="99" class="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                            Monthly Performance – Class GBP Acc.</th>
                                    </tr>
                                    <tr color="#d8e2e8" class="MonthlyPerformance__Row-sc-1n33bhd-4 elqUjA">

                                        {monthsArrayState.map(renderMonthNames)}


                                    </tr>
                                    
                                </tbody>
                            </table>

                            <table class="table MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW table-striped">
                                <tbody class="MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    
                                    {/* <tr class="MonthlyPerformance__Row-sc-1n33bhd-4 oKXFa"> */}
                                    
                                    {monthlyPerformance2DArrayState.map(render12MonthsData)}
                                    {/* </tr> */}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                     <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                      All information also available to download <a href={config.apiPath+"/sitepdfs/epic_next_gen_pcc.pdf"} target="_blank">here</a> 
                      <br/></p>
                  </div>
            </div>
          
          </div>

          
        </div>
      </div>
      <div class="tab-pane fade" id="two" role="tabpanel">
        <div class="row">
          <div class="col-sm-12">
          <div role="tabpanel" aria-hidden="false" class="fade tab-pane active show">
              <div class="mb-2 row">
                  <div class="col-md-12"  dangerouslySetInnerHTML={{ __html: productsCommentary }}>
                    {/* {productsCommentary} */}
                  {/* {bot3contriarray.map(renderbot3contri)} */}
                    
                    
                  </div>
                </div>
                <div class="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                     <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                      All information also available to download <a href={config.apiPath+"/sitepdfs/epic_next_gen_pcc.pdf"} target="_blank">here</a> 
                      <br/></p>
                  </div>
                    </div>            
          </div>
          
        </div>
      </div>
      <div class="tab-pane fade" id="three" role="tabpanel">
        <div class="row">
          <div class="col-sm-12">
            <div role="tabpanel" aria-hidden="false" class="fade tab-pane active show">
                <div class="mb-3 row">
                    <div class="col" >
                        <table class="FundInformation__Table-sc-18irt95-0 cRUpgb">
                            <tbody class=" FundInformation__Body-sc-18irt95-1 hNmQXY">
                                <tr class="FundInformation__Row-sc-18irt95-2 kzFInj">
                                    <th>Fund Information</th>
                                </tr>
                                {/* {Fundinfoarray.map(renderFundinfo)} */}
                                {CMSFundinfoarray.map(renderFundinfo)}
{/* 
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Fund Launch Date</td>   
                                  <td className="align-right">20 September 2012</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Sector</td>   
                                  <td className="align-right">FE – Equity International</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Pricing Frequency</td>   
                                  <td className="align-right">Daily</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Domicile</td>   
                                  <td className="align-right">Ireland</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Preliminary Charge</td>   
                                  <td className="align-right">Up To 5%</td>
                                </tr>
                                <tr className="FundInformation__Row-sc-18irt95-2 fweCQL">
                                  <td className="align-left">Exit Charge</td>   
                                  <td className="align-right">None</td>
                                </tr> */}
                               
                                {/* <tr class="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Fund Launch Date</td>
                                    <td>20 September 2012</td>
                                </tr>
                                <tr class="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Fund Size</td>
                                    <td>US$42.97m</td>
                                </tr>
                                <tr class="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>1 Day VaR (99%, 3 Year)</td>
                                    <td>1.77%</td>
                                </tr>
                                <tr class="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Margin to Equity</td>
                                    <td>12.68%</td>
                                </tr>
                                <tr class="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Gross Notional Exposure</td>
                                    <td>435.85%</td>
                                </tr>
                                <tr class="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Pricing Frequency</td>
                                    <td>Daily</td>
                                </tr>
                                <tr class="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Domicile</td>
                                    <td>Ireland</td>
                                </tr>
                                <tr class="FundInformation__Row-sc-18irt95-2 fweCQL">
                                    <td>Exit Charge</td>
                                    <td>None</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col" >
                        <table class="table  Shares__Table-sc-1brks4f-0 hBbtmd">
                            <tbody class="Shares__Body-sc-1brks4f-1 hbWYKC">
                                {/* <tr class="Shares__Row-sc-1brks4f-2 hzpAKA"> */}
                                

                                {/* {ShareClassarray.map(renderShareClassNames)} */}

                                    {/* <th class="text-left">Share Class</th>
                                    <th class="text-center">A USD</th>
                                    <th class="text-center">A GBP</th>
                                    <th class="text-center">A EUR</th>
                                    <th class="text-center">B USD</th>
                                    <th class="text-center">B GBP</th>
                                    <th class="text-center">B EUR</th> */}
                                {/* </tr> */}
                                <tr class="Shares__Row-sc-1brks4f-2 hzpAKA"><th class="align-left">Share Class</th>
                                <th class="align-center">Class X USD</th>
                                <th class="align-center">Class X GBP</th>
                                <th class="align-center">Class X CHF</th>
                                <th class="align-center">Class X EUR</th>
                                <th class="align-center">Class USD Participating</th>
                                <th class="align-center">Class GBP Participating</th>
                                <th class="align-center">Class CNH Participating</th>
                                </tr>
                                {/* <tr class="Shares__Row-sc-1brks4f-2 eoQrEv"> */}

                                {/* {ShareClassarray.map(renderShareClassValue)} */}

                                    {/* <td>NAV per Share</td>
                                    <td align="center" colspan="1">$995.86</td>
                                    <td align="center" colspan="1">£964.27</td>
                                    <td align="center" colspan="1">€820.02</td>
                                    <td align="center" colspan="1">$1,063.31</td>
                                    <td align="center" colspan="1">£795.17</td>
                                    <td align="center" colspan="1">€773.23</td> */}
                                {/* </tr> */}
                                {/* <tr class="Shares__Row-sc-1brks4f-2 eoQrEv"><td class="align-left">Minimum Initial Investment</td><td class="align-right">$100,000 </td><td class="align-right">$100,000 </td><td class="align-right">$100,000 </td><td class="align-right">$100</td><td class="align-right">$100</td><td class="align-right">$100</td></tr> */}
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">{label}</td> {/* First dynamic label */}
                                    {values.map((val, idx) => (
                                      <td key={idx} className="align-center">{val}</td>
                                    ))}
                                </tr>
                                
                                {CMSshareinfoarray.map(renderCMSshareinfo)}

                                {/* <tr class="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">Minimum Additional Investment</td>
                                    <td className="align-right">$10,000	</td>
                                    <td className="align-right">$10,000	</td>
                                    <td className="align-right">$10,000	</td>
                                    <td className="align-right">$100</td>
                                    <td className="align-right">$100</td>
                                    <td className="align-right">$100</td>
                                </tr>
                                <tr class="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">Ongoing Charge (as at 31 December 2020)</td>
                                    <td className="align-right">1.56%</td>
                                    <td className="align-right">1.56%</td>
                                    <td className="align-right">1.55%</td>
                                    <td className="align-right">1.81%</td>
                                    <td className="align-right">1.80%</td>
                                    <td className="align-right">1.81%</td>
                                 </tr>
                                <tr class="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">ISIN</td>
                                    <td className="align-right">IE00B86V3N61</td>
                                    <td className="align-right">IE00B8NCXV05</td>
                                    <td className="align-right">IE00B86JXG34</td>
                                    <td className="align-right">IE00B8L77L59</td>
                                    <td className="align-right">IE00B86KNN34</td>
                                    <td className="align-right">IE00B7S9LZ93</td>
                                </tr>
                                <tr class="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">Bloomberg Ticker</td>
                                    <td className="align-right">EEADTAU ID</td>
                                    <td className="align-right">EEADTAS ID</td>
                                    <td className="align-right">GARFTAE ID</td>
                                    <td className="align-right">EEADTBU ID</td>
                                    <td className="align-right">EEADTBS ID</td>
                                    <td className="align-right">GARFTBE ID</td>
                                </tr>
                                <tr class="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">Citi</td>
                                    <td className="align-right">MD8G</td>
                                    <td className="align-right">I2VK</td>
                                    <td className="align-right">Q6OF</td>
                                    <td className="align-right">I2VL</td>
                                    <td className="align-right">MD8J</td>
                                    <td className="align-right">NTGR</td>
                                </tr>
                                <tr class="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">MEXID</td>
                                    <td className="align-right">-</td>
                                    <td className="align-right">GAWXA</td>
                                    <td className="align-right">-</td>
                                    <td className="align-right">-</td>
                                    <td className="align-right">GACMA</td>
                                    <td className="align-right">GAYZA</td>
                                </tr>
                                <tr class="Shares__Row-sc-1brks4f-2 eoQrEv">
                                    <td className="align-left">Open for new investment</td>
                                    <td className="align-right">Yes</td>
                                    <td className="align-right">Yes</td>
                                    <td className="align-right">Yes</td>
                                    <td className="align-right">Yes</td>
                                    <td className="align-right">Yes</td>
                                    <td className="align-right">Yes</td>
                                </tr> */}


                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                     <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                      All information also available to download <a href={config.apiPath+"/sitepdfs/epic_next_gen_pcc.pdf"} target="_blank">here</a> 
                     <br/></p>
                  </div>
            </div>
            
          </div>
          
        </div>
      </div>
      <div class="tab-pane fade" id="four" role="tabpanel">
        <div class="row">
          <div class="col-sm-12">

          <div className="row">

         
          { KeyInveInfoState.length>0 ? <div class="col-md-12"><h3><b>Key Investor Information</b></h3><br/></div>  : ""}
          { KeyInveInfoState.length>0 ? KeyInveInfoState.map(renderLiteratureData) :""}
          
				  <div class="col-sm-12">
          <h4>Fact Sheet</h4>

					  <p class="pdf_download">
                      <a href={config.apiPath+"/sitepdfs/epic_next_gen_pcc.pdf"} target="_blank" download>Next Gen PCC Fund PDF
                            <br/>
                     </a>

                      </p>
				  </div>

          { PressCoverageState.length>0 ? <div class="col-md-12"><h3><b>Press Coverage</b></h3><br/></div>  : ""}
          { PressCoverageState.length>0 ? PressCoverageState.map(renderLiteratureData) :""}

          { LiteratureDataState.length>0 ? <div class="col-md-12"><h3><b>Other Information</b></h3><br/></div>  : ""}
          { LiteratureDataState.length>0 ? LiteratureDataState.map(renderLiteratureData) :""}

          { ApplicationsState.length>0 ? <div class="col-md-12"><h3><b>Applications</b></h3><br/></div>  : ""}
          { ApplicationsState.length>0 ? ApplicationsState.map(renderLiteratureData) :""}

          { ReportsState.length>0 ? <div class="col-md-12"><h3><b>Reports</b></h3><br/></div>  : ""}
          { ReportsState.length>0 ? ReportsState.map(renderLiteratureData) :""}

          { offerDocumentState.length>0 ? <div class="col-md-12"><h3><b>Offering Documents</b></h3><br/></div>  : ""}
          { offerDocumentState.length>0 ? offerDocumentState.map(renderLiteratureData) :""}
           


				  {/* <div class="col-sm-6">
					  <p class="pdf_download"><a href="files/2021-ESO-AGM-Proxy_32699907_3_0.pdf">2021 AGM Proxy Form<br/><span class="date">21 May 2021</span></a></p>
				  </div> */}
          </div>
          {/* <div class="row">
				  <div class="col-sm-6">
					  <p class="pdf_download"><a href="files/2021-05-20-ESO-AGM-Notice-V3-326976254-clean.pdf">2021 Notice of AGM
                      <br/><span class="date">20 May 2021</span></a></p>
				  </div>
				  <div class="col-sm-6">
					  <p class="pdf_download"><a href="files/2021-ESO-AGM-Proxy_32699907_3_0.pdf">2021 AGM Proxy Form<br/><span class="date">21 May 2021</span></a></p>
				  </div>
          </div>
          <div class="row">
				  <div class="col-sm-6">
					  <p class="pdf_download"><a href="files/2021-05-20-ESO-AGM-Notice-V3-326976254-clean.pdf">2021 Notice of AGM
                      <br/><span class="date">20 May 2021</span></a></p>
				  </div>
				  <div class="col-sm-6">
					  <p class="pdf_download"><a href="files/2021-ESO-AGM-Proxy_32699907_3_0.pdf">2021 AGM Proxy Form<br/><span class="date">21 May 2021</span></a></p>
				  </div>
          </div>
          <div class="row">
				  <div class="col-sm-6">
					  <p class="pdf_download"><a href="files/2021-05-20-ESO-AGM-Notice-V3-326976254-clean.pdf">2021 Notice of AGM
                      <br/><span class="date">20 May 2021</span></a></p>
				  </div>
				  <div class="col-sm-6">
					  <p class="pdf_download"><a href="files/2021-ESO-AGM-Proxy_32699907_3_0.pdf">2021 AGM Proxy Form<br/><span class="date">21 May 2021</span></a></p>
				  </div>
          </div>
          <div class="row">
				  <div class="col-sm-6">
					  <p class="pdf_download"><a href="files/2021-05-20-ESO-AGM-Notice-V3-326976254-clean.pdf">2021 Notice of AGM
                      <br/><span class="date">20 May 2021</span></a></p>
				  </div>
				  <div class="col-sm-6">
					  <p class="pdf_download"><a href="files/2021-ESO-AGM-Proxy_32699907_3_0.pdf">2021 AGM Proxy Form<br/><span class="date">21 May 2021</span></a></p>
				  </div>
          </div> */}
            
          </div>
          
        </div>
      </div>
      
    </div>
  </div>
    </div>
  </div>
</section>
:<div className="center"><ReactBootstrap.Spinner animation="border"/></div> 
}
</Fragment>
    );
}
 
export default EpicipPCCNextGenFunction;

